import {EFormSteps, EStatus, ETechPartnerStatus} from './definitions';

const registrationPoints = [
  'У вас есть номер телефона, на который будет зарегистрирован канал MAX.\n' +
    'Этот номер телефона не связан ни с каким другим аккаунтом.',
  'Пройдите регистрацию в MAX.',
  'Убедитесь, что аккаунт не заблокирован и вы можете отправлять/принимать сообщения в обычном режиме.',
  'Проверьте "Связанные устройства" в приложении. Если там много неактивных сессий, удалите их. \n' +
    'Это освободит "слот" для подключения к MAX.',
  'Убедитесь, что аккаунт, который вы хотите подключить, активен и доступен на вашем мобильном устройстве.',
  'Отключите дополнительный пароль для входа в настройках приложения MAX в разделе «Безопасность».',
];

export default {
  status: {
    [EStatus.DRAFT]: 'Черновик',
    [EStatus.LOGIN_REQUIRED]: 'Требует внимания',
    [EStatus.TOKEN_EXPIRED]: 'Требует внимания',
    [EStatus.IN_PROGRESS]: 'На регистрации',
    [EStatus.CREATE_SUBJECT]: 'На регистрации',
    [EStatus.CREATE_SUBJECT_ERROR]: 'Проблема',
    [EStatus.CANCELLED]: 'Отключен',
    [EStatus.DONE]: 'Работает исправно',
  },
  techPartnerStatus: {
    [ETechPartnerStatus.NEW]: 'Черновик',
    [ETechPartnerStatus.ACCEPTED]: 'Черновик',
    [ETechPartnerStatus.DELETED]: 'Отключен',
  },
  registrationCheck: {
    title: 'Проверьте, что у вас есть все необходимое для регистрации канала MAX',
    points: registrationPoints,
  },
  formSteps: {
    [EFormSteps.SETTINGS]: 'Условия регистрации и настройка',
    [EFormSteps.QR]: 'Подключение канала',
  },
  editForm: {
    settings: 'Настройки канала',
    subject: 'Отправитель',
    subjectHint:
      'Отправитель — системное имя канала, используется внутри edna Pulse и не отображается получателям',
    name: 'Внутреннее название канала',
    nameHint: 'Это название будет отображаться в списке каналов edna Pulse и в отчетности',
  },
  connectionLostBanner: {
    title: 'Соединение с каналом потеряно. Вы можете подключить канал повторно.',
    action: 'Подключить повторно',
  },
  connectionForm: {
    title: 'Подключение MAX',
    steps: [
      'Откройте приложение MAX на телефоне. Перейдите в Устройства <0>→</0> Войти по QR-коду. Наведите камеру на QR-код на экране.',
      'Не закрывайте страницу, пока статус канала не изменится на «Работает исправно» или система не выдаст ошибку.',
    ],
    qrTitle: 'Ваш QR-код для подключения',
    qrHint:
      'В момент перехода по ссылке QR-кода вы создадите новый канал MAX.\nДальше соединение с edna произойдет автоматически.',
    connectionError: 'Возникла непредвиденная ошибка. Соединение не установлено.',
  },
  connectionModal: {
    title: 'Подключаемся, секундочку',
    hint: 'edna устанавливает соединение по API с вашим каналом. Не покидайте страницу',
  },
  viewForm: {
    title: 'Данные канала',
    disconnect: 'Отключить канал',
  },
  disconnectModal: {
    title: 'Отключить канал?',
    hint: 'Отключение канала не влияет на активность лицензии. Для отключения лицензии, пожалуйста, свяжитесь с вашим менеджером.',
    submitButton: 'Отключить',
  },
  techPartner: {
    code: 'Ссылка для регистрации',
    codeHint: 'Скопируйте и отправьте эту ссылку клиенту, чтобы он завершил регистрацию канала MAX',
    connectionError: 'Соединение с каналом потеряно. Скопируйте ссылку ниже и отправьте её клиенту',
  },
  regenerateCodeModal: {
    title: 'Обновить ссылку для регистрации?',
    subTitle: 'После обновления текущая ссылка станет недействительной и будет создана новая',
  },
  publicForm: {
    title:
      'На этой странице вы можете зарегистрировать канал MAX. Информацию об этой регистрации получит ваш провайдер {{partnerName}}',
    helpTitle: 'Проверьте, что у вас есть все необходимое для регистрации канала MAX',
    helpPoints: registrationPoints,
    qrTitle: 'Ваш QR-код для подключения',
    qrHint:
      'Откройте приложение MAX на телефоне <0>→</0> Устройства <0>→</0> Войти по QR-коду. Наведите камеру на QR-код на экране.',
    advice: 'Как сделать MAX доверенным каналом и избежать блокировок',
    successTitle: 'Канал отправлен на регистрацию',
    successHint:
      'Узнать статус регистрации вы можете у своего провайдера<br/><0>{{partnerName}}</0>',
    errorTitle: 'По этой ссылке регистрация канала MAX недоступна:<br/><0>{{error}}</0>',
    errorHint:
      'Чтобы получить новую ссылку, свяжитесь с вашим провайдером<br/><0>{{partnerName}}</0>',
    errors: {
      unknown: 'такой страницы не существует',
    },
  },
};
